import { createRouter, createWebHistory } from 'vue-router'  // 1. 替换为createWebHistory

// 路由懒加载
const HomeView = () => import('../views/HomeView.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: "Qifeng Huimeng - Children's AI Intelligent Creation Platform",
      requiresAuth: false,
    }
  }
]

const router = createRouter({
  history: createWebHistory(),  // 2. 切换为历史模式（去掉#号）
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

// 可选：全局导航守卫（修改页面标题）
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router